"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const http_1 = require("../../utils/http");
const volkeno_react_skeleton_1 = __importDefault(require("volkeno-react-skeleton"));
const CGU = () => {
    var _a, _b;
    const [content, setContent] = (0, react_1.useState)("");
    const [loading, setLoading] = (0, react_1.useState)(true);
    const getFrontendOptions = () => {
        let requestForm = axios_1.default.get(`${http_1.ApiBaseUrl}getFrontendOptions`);
        requestForm.then((response) => {
            setContent(response.data.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            console.log('error', error);
        });
    };
    (0, react_1.useEffect)(() => {
        getFrontendOptions();
    }, []);
    return (react_1.default.createElement("div", { className: "cgu-component" },
        react_1.default.createElement("div", { className: "container cgu-container" },
            react_1.default.createElement("div", { className: "cgu-page-content" },
                react_1.default.createElement("div", { className: "row cgu-row" },
                    react_1.default.createElement("div", { className: "col-lg-12 cgu-col" },
                        react_1.default.createElement("div", { className: "cgu-content-body" },
                            (!!loading) && ([...Array(40)].map((item) => {
                                return react_1.default.createElement(volkeno_react_skeleton_1.default, { variant: 'text' });
                            })),
                            (!loading) && (((_a = content === null || content === void 0 ? void 0 : content.filter((item) => item.key === 'app_page_politique_confidentialite_text_long' && (item === null || item === void 0 ? void 0 : item.value) !== null)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                    __html: (_b = content === null || content === void 0 ? void 0 : content.filter((item) => item.key === 'app_page_politique_confidentialite_text_long' && (item === null || item === void 0 ? void 0 : item.value) !== null)[0]) === null || _b === void 0 ? void 0 : _b.value
                                } })) : ('Vide')))))))));
};
exports.default = CGU;
